<template>
    <div>
        <van-dropdown-menu>
            <van-dropdown-item v-model="dateValue" :options="option"></van-dropdown-item>
        </van-dropdown-menu>
    </div>
</template>

<script>
    export default {
        name: "Wp_date_select",
        props:{
           default:{type:Number,default:0}
        },
        data() {
            return {
                startTime: this.$common.dateFmt("yyyy-MM-dd", new Date()),
                endTime: this.$common.dateFmt("yyyy-MM-dd", new Date()),
                dateValue:0,
                option: [
                    {text: '今日', value: 0},
                    {text: '昨日', value: 1},
                    {text: '近7日', value: 2},
                    {text: '近30日', value: 3},
                    {text: '近60日', value: 4},
                    {text: '近90日', value: 5},
                ]
            };
        },
        watch: {
            dateValue(newV, oldV) {
                this.selectDate(newV);
            }
        },
        created() {
            this.dateValue=this.default;
            this.selectDate(this.dateValue);
        },
        methods: {
            selectDate(value) {
                this.$log(value);
                let startFix = 0;
                let endFix = 0;
                switch (value) {
                    case 0: {
                        startFix = 0;
                        endFix = 0;
                        break;
                    }
                    case 1: {
                        startFix = -1;
                        endFix = -1;
                        break;
                    }
                    case 2: {
                        startFix = -6;
                        endFix = 0;
                        break;
                    }
                    case 3: {
                        startFix = -29;
                        endFix = 0;
                        break;
                    }
                    case 4: {
                        startFix = -59;
                        endFix = 0;
                        break;
                    }
                    case 5: {
                        startFix = -89;
                        endFix = 0;
                        break;
                    }
                }
                this.startTime = this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', startFix, new Date()));
                this.endTime = this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', endFix, new Date()));
                let _dateSelect = {
                    startTime: this.startTime,
                    endTime: this.endTime,
                };
                this.$emit('onDateSelect', _dateSelect)
            }
        }
    }
</script>

<style scoped>
    .van-dropdown-menu{
        height: 30px;
        width:100px;
    }

    .van-dropdown-menu__title{
        font-size: 14px;
    }
    .van-hairline--top-bottom::after {
        border: 0 solid #fff;
        font-size: 14px;
    }

</style>